var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_copy",
    clipPath: "url(#clip0_2578_125660)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3334 0.833008H3.33341C2.41675 0.833008 1.66675 1.58301 1.66675 2.49967V14.1663H3.33341V2.49967H13.3334V0.833008ZM12.5001 4.16634H6.66675C5.75008 4.16634 5.00841 4.91634 5.00841 5.83301L5.00008 17.4997C5.00008 18.4163 5.74175 19.1663 6.65841 19.1663H15.8334C16.7501 19.1663 17.5001 18.4163 17.5001 17.4997V9.16634L12.5001 4.16634ZM6.66675 17.4997V5.83301H11.6667V9.99967H15.8334V17.4997H6.66675Z",
    fill: "#4B6D98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2578_125660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.ab4fdaa78e735de77f82c1b23059a1e2.svg";
export { ForwardRef as ReactComponent };